import * as bi from 'react-bootstrap-icons';
import { Box, Button, Flex, Header } from 'components';

interface IProps {
  open: boolean;
  onOpenClick: () => void;
  title: string;
  children?: React.ReactNode;
  className?: string;
}

function SpoilerCard(props: IProps) {
  return (
    <Box
      padding={20}
      onClick={!props.open ? props.onOpenClick : undefined}
      className={props.className}
    >
      <Flex
        direction='column'
        gap={10}
      >
        <Flex
          justifyContent='space-between'
          alignItems='center'
          onClick={props.open ? props.onOpenClick : undefined}
        >
          <Header>{props.title}</Header>
          <Button
            color='transparent-blue'
            size='small'
          >
            <Flex alignItems='center'>{props.open ? <bi.ChevronUp /> : <bi.ChevronDown />}</Flex>
          </Button>
        </Flex>
        {props.children != null && props.open && props.children}
      </Flex>
    </Box>
  );
}

export default SpoilerCard;
